<div
  class="min-h-screen"
  *ngIf="order$ | async as order"
>
  <h1 class="hidden lg:block py-12 font-accent font-bold text-5xl text-center">
    {{ 'order-details.title' | translate }}
  </h1>
  <div
    class="bg-primary-600 h-30 lg:w-8/12 lg:mx-auto lg:rounded-lg mb-6 md:h-40 flex items-center md:justify-center"
  >
    <i class="icon icon-shop text-white text-5xl pl-6 md:text-6.5xl pr-4 md:pr-5"></i>
    <div class="flex flex-col font-accent">
      <div class="text-white font-bold leading-8 lg:leading-11 text-28px md:text-4xl">
        {{ order[orderKeys.Shop]?.name }}
      </div>
      <div
        *ngIf="
          orderReadyAt &&
          order.type !== orderTypeValues.OnSite &&
          order.type !== orderTypeValues.EatIn
        "
        class="text-white text-sm md:text-md"
      >
        {{ orderReadyAt }}
      </div>
    </div>
  </div>
  <div class="lg:hidden max-w-screen-sm mx-auto">
    <div class="px-5 mb-5">
      <div class="border border-neutral-300 rounded-lg">
        <app-order-status-atom-v2
          [orderStatus]="order[orderKeys.Status]"
          [shopName]="order[orderKeys.Shop]?.name"
          [orderNumber]="order[orderKeys.Number]"
          [order]="order"
          [displayDetailsButton]="false"
          [locationName]="onSiteLocationName$ | async"
        ></app-order-status-atom-v2>
      </div>
    </div>
    <div *ngIf="order[orderKeys.LineItems]">
      <div class="px-5 py-4">
        <h1 class="font-accent font-bold text-2xl lg:text-3xl text-neutral-800">
          {{ 'order-details.overview' | translate }}
        </h1>
      </div>
      <div class="mb-4">
        <app-detail-order-atom
          [lineItems]="order[orderKeys.LineItems]"
          [totalAmount]="order[orderKeys.FinalPrice]"
          [tips]="order[orderKeys.Tip]?.amount"
          [paidAmount]="order[orderKeys.PaidAmount]"
        ></app-detail-order-atom>
      </div>
      <div>
        <app-detail-order-voucher-block
          *ngIf="order[orderKeys.Coupons]"
        ></app-detail-order-voucher-block>
      </div>
    </div>
    <div class="p-5">
      <app-button-atom
        [full]="true"
        [type]="'primary'"
        [size]="'M'"
        [label]="'order-details.new-order' | translate"
        [icon]="'icon-redo-arrow'"
        (click)="renewOrder(order)"
      ></app-button-atom>
    </div>
  </div>
  <div class="hidden lg:grid grid-cols-2 gap-8 lg:w-8/12 mx-auto">
    <div
      class="bg-neutral-100 rounded-lg"
      *ngIf="order[orderKeys.LineItems]"
    >
      <div class="px-5 py-4 lg:p-6">
        <h1 class="font-accent font-bold text-2xl lg:text-3xl text-neutral-800">
          {{ 'order-details.overview' | translate }}
        </h1>
      </div>
      <div>
        <app-detail-order-atom
          [lineItems]="order[orderKeys.LineItems]"
          [totalAmount]="order[orderKeys.FinalPrice]"
          [tips]="order[orderKeys.Tip]?.amount"
          [paidAmount]="order[orderKeys.PaidAmount]"
        ></app-detail-order-atom>
      </div>
      <div class="px-5 pb-5">
        <app-button-atom
          [full]="true"
          [type]="'primary'"
          [size]="'M'"
          [label]="'order-details.new-order' | translate"
          [icon]="'icon-redo-arrow'"
          (click)="renewOrder(order)"
        ></app-button-atom>
      </div>
    </div>
    <div>
      <div class="border border-neutral-300 rounded-lg mb-8">
        <app-order-status-atom-v2
          [displayDetailsButton]="false"
          [orderStatus]="order[orderKeys.Status]"
          [shopName]="order[orderKeys.Shop]?.name"
          [orderNumber]="order[orderKeys.Number]"
          [order]="order"
        ></app-order-status-atom-v2>
      </div>
      <div>
        <app-detail-order-voucher-block
          *ngIf="order[orderKeys.Coupons]"
        ></app-detail-order-voucher-block>
      </div>
    </div>
  </div>
</div>
